/**
 * @ Author: Housefolios
 * @ Create Time: 2021-10-05 11:07:32
 * @ Modified by: David Helmick
 * @ Modified time: 2024-06-07 14:43:22
 * @ Modified by: David Helmick
 * @ Modified time: 2025-08-18 14:50:22
 * @ Description: Dialog to copy a property - Now using the generic duplicate entity system
 */

import React from 'react'
import { DuplicateProperty as GenericDuplicateProperty } from '@/housefolios-components/shared/DuplicateEntity'
import withSession from '@/housefolios-components/Session/withSession'

/**
 * DuplicateProperty Component
 *
 * This component is now a thin wrapper around the generic duplicate entity system.
 * It maintains backward compatibility while leveraging the new centralized system.
 *
 * @param {Object} props - Component props
 * @param {string} props.propertyId - ID of the property to duplicate
 * @param {Object} props.property - The property object
 * @param {Array} props.portfolios - Available portfolios
 * @param {string} props.selectedPortfolio - Currently selected portfolio
 * @param {Function} props.setSelected - Function to clear selection after duplication
 * @param {boolean} props.notifications - Whether to show as notification menu item
 * @param {boolean} props.rightClickMenu - Whether to show as right-click menu item
 * @param {string} props.buttonText - Custom button text
 * @param {Object} props.session - User session object
 * @param {boolean} props.underwriting - Whether this is for underwriting context
 */
function DuplicatePropertyComponent(props) {
  // Extract the specific props we need for the generic component
  const {
    propertyId,
    property,
    portfolios,
    selectedPortfolio,
    setSelected,
    notifications,
    rightClickMenu,
    buttonText,
    session,
    underwriting,
    ...otherProps
  } = props

  // Pass through all props to the generic component
  return (
    <GenericDuplicateProperty
      propertyId={propertyId}
      property={property}
      portfolios={portfolios}
      selectedPortfolio={selectedPortfolio}
      setSelected={setSelected}
      notifications={notifications}
      rightClickMenu={rightClickMenu}
      buttonText={buttonText}
      underwriting={underwriting}
      session={session}
      {...otherProps}
    />
  )
}

export default withSession(DuplicatePropertyComponent)
